import { AppService } from "app/services/app.service";

import { ConfigRelAgendamentoAmbiente } from "app/models/configrelagendamentoambiente.model";
import { Observable } from "rxjs";

export abstract class AbConfiguracaoAgendRelAmb extends AppService {

  abstract getConfigRelAgendAmb(): Observable<any>;
  abstract saveConfigRelAgendAmb(config: ConfigRelAgendamentoAmbiente): Observable<any>
}